var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23.2,
    viewBox: "0 0 29 23.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "User_Management",
    "data-name": "User Management",
    d: "M28.275,9.425h-2.9v-2.9A.727.727,0,0,0,24.65,5.8H23.2a.727.727,0,0,0-.725.725v2.9h-2.9a.727.727,0,0,0-.725.725V11.6a.727.727,0,0,0,.725.725h2.9v2.9a.727.727,0,0,0,.725.725h1.45a.727.727,0,0,0,.725-.725v-2.9h2.9A.727.727,0,0,0,29,11.6V10.15A.727.727,0,0,0,28.275,9.425ZM10.15,11.6a5.8,5.8,0,1,0-5.8-5.8A5.8,5.8,0,0,0,10.15,11.6Zm4.06,1.45h-.757a7.888,7.888,0,0,1-6.607,0H6.09A6.092,6.092,0,0,0,0,19.14v1.885A2.176,2.176,0,0,0,2.175,23.2h15.95A2.176,2.176,0,0,0,20.3,21.025V19.14A6.092,6.092,0,0,0,14.21,13.05Z",
    fill: "#03d9d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/User Management.6db53e6f49fd2ac6e6cad1955b32d9ec.svg";
export { ForwardRef as ReactComponent };